import React from 'react'
import { Typography } from '@material-ui/core'
import { useAmountStyles } from './styles'
import { useAmountTranslation } from './translation'
import { formatMoney } from '@itarget/shared'

const Amount = ({
  amount,
  discount,
  discountedAmount,
  unavailable,
  registrationFee,
  installments,
}) => {
  const styles = useAmountStyles()
  const translation = useAmountTranslation()

  if (unavailable) {
    return (
      <div className={styles.unavailableContainer}>
        <Typography className={styles.unavailable}>
          {translation.unavailable}
        </Typography>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {discount && (
        <div className={styles.discountContainer}>
          <div className={styles.chip}>
            <Typography className={styles.discountText}>
              {translation.discount}
            </Typography>
          </div>
          <Typography className={styles.amount}>
            <span className={styles.currencySymbol}>R$</span>
            {formatMoney.toReal(amount)}
          </Typography>
          <Typography className={styles.amountDiscounted}>
            {installments > 1 ? (
              `${installments}x R$ ${formatMoney.toReal(discountedAmount)}`
            ) : (
              `R$ ${formatMoney.toReal(discountedAmount)}`
            )}
          </Typography>
        </div>
      )}
      {!discount && (
        <Typography className={styles.amount}>
          {installments > 1 ? (
            `${installments}x R$ ${formatMoney.toReal(amount)}`
          ) : (
            <>
              <span className={styles.currencySymbol}>R$</span>
              {formatMoney.toReal(amount)}
            </>
          )}
        </Typography>
      )}
      {registrationFee > 0 && (
        <Typography className={styles.registrationFee}>
          {`${translation.registrationFee}: R$ ${formatMoney.toReal(registrationFee)}`}
        </Typography>
      )}
    </div>
  )
}

export default Amount
